<template>
    <modal
        name="register"
        :classes="['v--modal', 'register', 'error-modal']"
        @before-open="beforeOpen"
        @before-close="beforeClose"
        :width="400"
        :height="'auto'"
        :adaptive="true"
    >
        <div class="modal-title">{{ $t("register.register") }}</div>
        <div class="modal-close" @click="close"></div>
        <div class="modal-body">
            <section class="register">
                <form @submit.prevent="register" autocomplete="on">
                    <div class="form-group">
                        <label for="username" class="label"
                            >{{ $t("register.phoneEmail") }} :</label
                        >
                        <input
                            v-model="username"
                            type="text"
                            name="username"
                            id="username"
                            v-validate="{ required: true, phoneOrMail: true }"
                            autocomplete="username"
                            class="input"
                        />
                        <!-- :class="{ 'field-error': errors.has('username') }" -->

                        <!-- TODO: Убирает напись "формат телефона: +XХХХХХХХХХХ (не менее 11 символов)"  -->
                        <!-- <label for="username" class="v-error label-tip">{{
                            errors.first("username")
                        }}</label> -->

                        <!-- <label for="username" class="v-error label-tip">
                            {{ errors.has('email') ? errors.first('email') : errors.first('phone') }}
                        </label> -->

                        <!-- <label for="username" class="v-error label-tip" v-if="errorMessages.length > 0">
                            {{ errorMessages.join(', ') }}
                        </label> -->
                    </div>
                    <div class="form-group">
                        <label for="register-password" class="label"
                            >{{ $t("register.password") }} :</label
                        >
                        <input
                            type="password"
                            v-model="password"
                            name="register-password"
                            id="register-password"
                            ref="password"
                            v-validate="'required|min:6'"
                            autocomplete="new-password"
                            class="input"
                            :class="{
                                'field-error': errors.has('register-password'),
                            }"
                        />

                        <label
                            for="register-password"
                            class="v-error label-tip"
                        >
                            {{ errors.first("register-password") }}
                        </label>
                    </div>

                    <div class="form-group">
                        <label for="password-confirm" class="label"
                            >{{ $t("register.confirmPassword") }} :</label
                        >
                        <input
                            v-model="passwordConfirm"
                            type="password"
                            name="password-confirm"
                            id="password-confirm"
                            v-validate="'required|confirmed:password|min:6'"
                            autocomplete="new-password"
                            class="input"
                            :class="{
                                'field-error': errors.has('password-confirm'),
                            }"
                        />

                        <label for="password" class="v-error label-tip">
                            {{ errors.first("password-confirm") }}
                        </label>
                    </div>
                    <div class="form-tip">
                        {{ $t("register.ByRegisterButton") }}
                        <redirectButton
                            pathname="rules"
                            :html="$t('footer.footerRules')"
                            class="link-blue-underlined"
                            target="_blank"
                        ></redirectButton>
                        {{ $t("register.and") }}
                        <redirectButton
                            pathname="legal"
                            :html="$t('register.dataUsePolicy')"
                            class="link-blue-underlined"
                            target="_blank"
                        ></redirectButton
                        >.
                    </div>
                    <div class="form-bottom">
                        <button
                            v-if="!loader"
                            type="submit"
                            class="button-blue"
                        >
                            {{ $t("register.register") }}
                        </button>
                        <button v-if="loader" class="button-loader"></button>
                        <Social />
                    </div>
                </form>
            </section>
        </div>
    </modal>
</template>

<script>
import { mapGetters } from "vuex";
import redirectButton from "@/components/Buttons/Redirect";
import Social from "@/components/Blocks/Social";
import { localizeValidation } from "@/mixins/localizeValidation";
import { checkScroll } from "@/mixins/checkScroll";

export default {
    name: "Register",
    props: {
        i18n: Object,
    },
    components: {
        redirectButton,
        Social,
    },
    mixins: [localizeValidation, checkScroll],
    data() {
        return {
            username: "",
            password: "",
            passwordConfirm: "",
            phone: "",
            email: "",
            loader: false,
            nonFieldErrors: [],
            serverErrors: [],
            errorMessages: [],
        };
    },
    computed: {
        ...mapGetters({
            userErrors: "user/errors",
            isEmpty: "user/isEmpty",
            registerData: "user/fetchRegisterData",
        }),
    },
    created() {
        this.localizeValidation();

        let self = this;

        const phoneOrMailRule = {
            getMessage(field, isPhoneOrMail, data) {
                return (
                    (data && data.message) ||
                    self.$t("feedback.enterCorrectAddress")
                );
            },

            validate(value, isPhoneOrMail) {
                if (isPhoneOrMail) {
                    if (self.username.indexOf("@") >= 0) {
                        //email
                        const regexMail =
                            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        self.email = self.username;
                        self.phone = "";
                        return {
                            data: {
                                message: self.$t(
                                    "feedback.enterValidEmailAddress"
                                ),
                            },
                            valid: regexMail.test(self.username),
                        };
                    } else if (
                        /^\+/.test(self.username) ||
                        /[0-9]{2,}/.test(self.username)
                    ) {
                        //phone
                        self.phone = self.username.replace(/[^+0-9.]/g, "");
                        // const regexPhone = /^\+[0-9]{11,}$/;
                        self.phone = self.username;
                        self.email = "";
                        return {
                            data: { message: self.$t("feedback.phoneFormat") },
                            valid: self.phone.length >= 10,
                            // valid: regexPhone.test(self.phone),
                        };
                    }
                    return { data: null, valid: false };
                } else {
                    return { valid: true };
                }
            },
        };

        this.$validator.extend("phoneOrMail", phoneOrMailRule);
    },
    methods: {
        beforeOpen(event) {
            this.checkScroll();
        },
        beforeClose() {
            this.checkRemoveScroll();
        },
        close() {
            this.$modal.hide("register");
        },
        isNumeric(value) {
            return /^\d+$/.test(value);
        },
        formatPhoneNumber(phoneNumber) {
            let cleaned = ("" + phoneNumber)
                .replace(/\D/g, "")
                .substring(0, 11);
            if (cleaned.startsWith("8")) {
                cleaned = "7" + cleaned.slice(1);
            }
            let formatted = cleaned.replace(
                /(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/,
                "+$1$2$3$4$5"
            );
            return formatted;
        },
        register() {
            // Удаляем пробелы в конце строки перед форматированием номера телефона
            let trimmedPhone = this.phone.trim();
            let trimmedEmail = this.email.trim();

            // Проверяем, если строка содержит ".ru" или ".com", то она скорее всего почта, а не номер телефона
            let isEmail =
                trimmedEmail.includes(".ru") || trimmedEmail.includes(".com");

            // Форматируем номер телефона только если введены цифры и это не почта
            let formattedPhone =
                !isEmail && this.isNumeric(trimmedPhone)
                    ? this.formatPhoneNumber(trimmedPhone)
                    : trimmedPhone;

            this.$validator.validateAll().then((valid) => {
                if (valid) {
                    this.loader = true;

                    this.$store
                        .dispatch("user/create", {
                            phone: formattedPhone,
                            email: trimmedEmail,
                            password: this.password,
                        })
                        .then(() => {
                            this.$store.dispatch("user/setRegister", false);
                            if (this.registerData.phone) {
                                this.$modal.show("confirm-phone", {
                                    register: true,
                                    phone: this.registerData.phone,
                                    password: this.password,
                                });
                            } else {
                                this.$modal.show("dialog", {
                                    title: this.$t(
                                        "register.youForRegistering"
                                    ),
                                    text: this.$t(
                                        "register.completeTheRegistration"
                                    ),
                                    buttons: [
                                        {
                                            title: this.$t("albumEdit.ok"),
                                        },
                                    ],
                                });
                            }
                            this.loader = false;
                        })
                        .catch((err) => {
                            for (let key in this.userErrors) {
                                this.errors.add({
                                    field: key,
                                    msg: this.userErrors[key][0],
                                });
                                console.log("key:", key);
                            }
                            if (this.userErrors.email) {
                                this.errors.add({
                                    field: "email",
                                    msg: this.$t("register.userEmailExists"),
                                });
                            }
                            if (this.userErrors.phone) {
                                this.errors.add({
                                    field: "phone",
                                    msg: this.$t("register.userPhoneExists"),
                                });
                            }
                            this.loader = false;
                        });
                }
            });
        },
        // register() {
        //     this.$validator.validateAll().then((valid) => {
        //         if (valid) {
        //             this.loader = true;

        //             this.$store
        //                 .dispatch("user/create", {
        //                     phone: this.phone,
        //                     email: this.email,
        //                     password: this.password,
        //                 })
        //                 .then(() => {
        //                     this.$store.dispatch("user/setRegister", false);
        //                     if (this.registerData.phone) {
        //                         this.$modal.show("confirm-phone", {
        //                             register: true,
        //                             phone: this.registerData.phone,
        //                             password: this.password,
        //                         });
        //                     } else {
        //                         this.$modal.show("dialog", {
        //                             title: this.$t(
        //                                 "register.youForRegistering"
        //                             ),
        //                             text: this.$t(
        //                                 "register.completeTheRegistration"
        //                             ),
        //                             buttons: [
        //                                 {
        //                                     title: this.$t("albumEdit.ok"),
        //                                 },
        //                             ],
        //                             // title: this.$t("register.youForRegistering"),
        //                             // text: this.$t("register.completeTheRegistration"),
        //                             // buttons: [
        //                             //     {
        //                             //         title: this.$t("albumEdit.ok"),
        //                             //     },
        //                             // ],
        //                         });
        //                     }
        //                     this.loader = false;
        //                 })
        //                 .catch((err) => {
        //                     for (let key in this.userErrors) {
        //                         this.errors.add({
        //                             field: key,
        //                             msg: this.userErrors[key][0],
        //                         });
        //                         console.log("key:", key);
        //                     }
        //                     if (this.userErrors.email) {
        //                         this.errors.add({
        //                             field: "email",
        //                             msg: self.$t("register.userEmailExists"),
        //                         });
        //                     }
        //                     if (this.userErrors.phone) {
        //                         this.errors.add({
        //                             field: "phone",
        //                             msg: self.$t("register.userPhoneExists"),
        //                         });
        //                     }
        //                     this.loader = false;

        //                     // this.errorMessages = [];
        //                     // for (let key in this.userErrors) {
        //                     //     if (!this.errorMessages.includes(this.userErrors[key][0])) {
        //                     //         this.errorMessages.push(this.userErrors[key][0]);
        //                     //     }
        //                     //     console.log('key:', key);
        //                     // }
        //                     // if (this.userErrors.email && !this.errorMessages.includes('Пользователь с таким email уже существует!')) {
        //                     //     this.errorMessages.push('Пользователь с таким email уже существует');
        //                     // }
        //                     // if (this.userErrors.phone && !this.errorMessages.includes('Пользователь с таким телефоном уже существует!')) {
        //                     //     this.errorMessages.push('Пользователь с таким телефоном уже существует');
        //                     // }
        //                     // this.loader = false;

        //                     // this.errorMessages = [];
        //                     // for (let key in this.userErrors) {
        //                     //     this.errorMessages.push(this.userErrors[key][0]);
        //                     //     console.log('key:', key);
        //                     // }
        //                     // if (this.userErrors.email) {
        //                     //     this.errorMessages.push('Пользователь с таким email уже существует');
        //                     // }
        //                     // if (this.userErrors.phone) {
        //                     //     this.errorMessages.push('Пользователь с таким телефоном уже существует');
        //                     // }
        //                     // this.loader = false;
        //                 });
        //         }
        //     });
        // },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_validation";
@import "~@/assets/styles/layout/_register";
</style>
